export default __webpack_public_path__ + "static/media/home_right.c9cb2909.png";